import { getAllCycles } from '../../../../../VisitSchedules/routes/VisitSchedulesPage/utils/visitsScheduleUtils'
import { resolveProjectedStudyDaysForCycle } from '../../../../../VisitSchedules/routes/VisitScheduleNav/routes/VisitPage/utils/visitDayUtils'

export const findArmById = (arms = [], armId) => {
  if (armId == null || armId === '') return null
  const key = String(armId)
  return (
    arms.find(arm => arm?.id != null && String(arm.id) === key) ||
    arms.find(arm => arm?.arm_id != null && String(arm.arm_id) === key) ||
    null
  )
}

const boundsFromProjectedDays = (projectedStart, projectedEndExclusive) => {
  const start = Number(projectedStart)
  const endExclusive = Number(projectedEndExclusive)
  if (!Number.isFinite(start) || start < 1) return null
  const end = Number.isFinite(endExclusive)
    ? Math.max(start, Math.max(1, endExclusive - 1))
    : start
  return { start, end }
}

const boundsFromCycleMetadata = cycle => {
  const metaStart = cycle.metadata?.projected_study_day
  const metaEnd = cycle.metadata?.projected_study_end_day
  if (metaStart == null || metaStart === '' || metaEnd == null || metaEnd === '') return null
  return boundsFromProjectedDays(metaStart, metaEnd)
}

/**
 * Cycle bounds for timeline projection. Uses visit-schedule resolution first, then
 * metadata.projected_study_* when length_value/anchor chain resolution fails (common on API payloads).
 * @returns {{ start: number, end: number } | null}
 */
export const getResolvedCycleStudyDayBounds = (cycle, allCycles) => {
  if (!cycle || cycle.is_dummy || cycle.metadata?.is_dummy) return null
  const resolved = resolveProjectedStudyDaysForCycle(cycle, allCycles)
  if (resolved) {
    const fromResolved = boundsFromProjectedDays(
      resolved.projected_study_day,
      resolved.projected_study_end_day,
    )
    if (fromResolved) return fromResolved
  }
  return boundsFromCycleMetadata(cycle)
}

export const allCyclesForArms = (arms = []) => {
  const cycles = getAllCycles(arms) || []
  return cycles.filter(c => c && !c.is_dummy && !c.metadata?.is_dummy)
}
